import React, { useContext, useEffect, useRef, useState } from 'react';
import { BarChartContainer, BarIndicator, Container, LayerCaption } from './style';
import { makeArray, makeVirgula } from '../../../../../utils/factorys';
import { RankingContext } from '@/context/ranking';
import { BarChart } from '../../../atoms/Graph/barChart';
import { StateProps } from '../../../atoms/interfaces';

interface GraphProps {
  data: any
}

export const Graph: React.FC<GraphProps> = ({ data }) => {
  const [StatesGeral, setStateGeral] = useState<StateProps[]>([]);
  const { researchArea, setRankingSort, rankingSort, setFirstPosition } = useContext(RankingContext);

  const [valueStep, setValueStep] = useState<number[]>([])

  function flooatTwo(n: number) {
    return (Math.round(n * 100) / 100).toFixed(2);
  }

  const makeStep = () => {
    if (rankingSort[0]?.indice !== undefined) {
      const arr: any = [makeVirgula(Number(flooatTwo(rankingSort[0]?.indice)))]
      const step = rankingSort[0]?.indice;

      for (let i = 1; i < 4; i++) {
        const sub = ((i * 20) / 100)
        const result = (step - sub)
        arr.push(makeVirgula(Number(flooatTwo(result < 0 ? result * -1 : result))))
      }

      if (arr.length == 4) {
        arr.push('0,00')
      }
      setFirstPosition(rankingSort[0])
      setValueStep(arr)
    }
  }

  useEffect(() => {
    const arr = makeArray(data[researchArea]?.ranking)
    function compare(a: any, b: any) {
      if (a.posicao < b.posicao) {
        return -1;
      }
      if (a.posicao > b.posicao) {
        return 1;
      }
      return 0;
    }
    arr.sort(compare);
    setStateGeral(arr);
    setRankingSort(arr);
  }, [data, researchArea]);

  useEffect(() => {
    makeStep()
  }, [rankingSort])
  
  return (
    <Container>
      <BarChartContainer style={{ marginRight: '10px' }}>
        <BarIndicator >
          <LayerCaption >
            <p>{valueStep[0]}-</p>
          </LayerCaption>
          <LayerCaption >
            <p>{valueStep[1]}-</p>
          </LayerCaption>
          <LayerCaption >
            <p>{valueStep[2]}-</p>
          </LayerCaption>
          <LayerCaption >
            <p>{valueStep[3]}-</p>
          </LayerCaption>
          <LayerCaption >
            <p>{valueStep[4]}-</p>
          </LayerCaption>
        </BarIndicator>
        <span></span>
      </BarChartContainer>
      {
        // state?.sigla
        StatesGeral.map((state: StateProps) => (
          <BarChart key={Math.random()} value={state} />
        ))
      }
    </Container>
  );
};
